<div #tagPanel *ngIf="filterTagModelList.length" class="u-mh--- u-mb---">
  <span *ngIf="headerLabel" class="text-14 u-pl----">
    {{ headerLabel | translate }}
  </span>
  <ng-container *ngIf="showAllTags; then allTagsMode else collapsingTagsMode">
  </ng-container>
</div>

<ng-template #allTagsMode>
  <div #tagContainer>
    <ng-container *ngFor="let filterTagModel of filterTagModelList; index as i">
      <div class="u-m---- filter-panel__tag-element" style="display: inline-block; vertical-align: middle">
        <wfm-filter-tag fillColor="true" (close)="onRemoveTag(filterTagModel)">
          <span *ngIf="filterTagModel.label" class="u-pr--- u-mr--- filter-tag--fill-pipe">
            {{ filterTagModel.label | translate }}
          </span>
          <span>
            {{ filterTagModel.filterTag.description | translate }}
          </span>
        </wfm-filter-tag>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #collapsingTagsMode>
  <div> <!-- Div is needed so floating div below vertically aligns with the top of the tags. -->
    <div *ngIf="isMultiLine" style="float: right">
      <button *ngIf="showToggle && isCollapsed" type="button" aria-pressed="false"
        class="button--no-border button button--tertiary u-p---" (click)="isCollapsed = !isCollapsed">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
          class="button__icon button__icon--color">
          <g>
            <path
              d="M8,11.5a.47.47,0,0,1-.35-.15l-6.5-6.5a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0L8,10.29l6.15-6.14a.49.49,0,0,1,.7.7l-6.5,6.5A.47.47,0,0,1,8,11.5Z">
            </path>
          </g>
        </svg>
        <span>{{ 'vg.showAll' | translate }}</span>
      </button>
      <button *ngIf="showToggle && !isCollapsed" type="button" aria-pressed="false"
        class="button--no-border button button--tertiary u-p---" (click)="isCollapsed = !isCollapsed">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
          class="button__icon button__icon--color">
          <g>
            <path
              d="M14.5,11.5a.47.47,0,0,1-.35-.15L8,5.21,1.85,11.35a.48.48,0,0,1-.7,0,.48.48,0,0,1,0-.7l6.5-6.5a.48.48,0,0,1,.7,0l6.5,6.5a.48.48,0,0,1,0,.7A.47.47,0,0,1,14.5,11.5Z">
            </path>
          </g>
        </svg>
        <span>{{ 'vg.showLess' | translate }}</span>
      </button>
      <button type="button" aria-pressed="false" class="button--no-border button button--tertiary u-p---"
        (click)="onClearAll()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
          class="button__icon button__icon--color">
          <g>
            <path
              d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.85,10.44a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L8,9.41,5.56,11.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L6.59,8,4.15,5.56a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0L8,6.59l2.44-2.44a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71L9.41,8Z">
            </path>
          </g>
        </svg>
        <span>{{ 'vg.clearAll' | translate }}</span>
      </button>
    </div>
    <div #tagContainer [ngStyle]="{ isMultiLine: isMultiLine, isCollapsed: isCollapsed, lineHeight: lineHeight } | tagContainerStyle">
      <ng-container *ngFor="let filterTagModel of filterTagModelList; index as i">
        <div class="u-p---- filter-panel__tag-element" style="display: inline-block; vertical-align: middle">
          <wfm-filter-tag fillColor="true" (close)="onRemoveTag(filterTagModel)">
            <span *ngIf="filterTagModel.label" class="u-pr--- u-mr--- filter-tag--fill-pipe">
              {{ filterTagModel.label | translate }}
            </span>
            <span>
              {{ filterTagModel.filterTag.description | translate }}
            </span>
          </wfm-filter-tag>
        </div>
      </ng-container>
      <div *ngIf="!isMultiLine" style="display: inline-block; vertical-align: middle">
        <button type="button" aria-pressed="false" class="button--no-border button button--tertiary u-p---"
          (click)="onClearAll()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
            class="button__icon button__icon--color">
            <g>
              <path
                d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.85,10.44a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L8,9.41,5.56,11.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L6.59,8,4.15,5.56a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0L8,6.59l2.44-2.44a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71L9.41,8Z">
              </path>
            </g>
          </svg>
          <span>{{ 'vg.clearAll' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>